var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ops-card',{attrs:{"title":_vm.$tc('phrases.transactionsPerMonth')}},[_c('div',{staticClass:"tenant-chart"},[_c('v-chart',{staticClass:"tenant-chart__canvas",attrs:{"option":_vm.option,"autoresize":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }